import { Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="relative border-t border-white/5 pt-16 pb-10"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2.5">
              <img
                src="/omnicoretek-logo.png"
                alt="OmniCoreTek logo"
                className="h-8 w-8 object-contain"
                style={{ filter: "drop-shadow(0 0 6px rgba(0,229,255,0.35))" }}
              />
              <span className="font-display text-xl tracking-tight">
                Omni<span className="text-electric-500">Core</span>Tek
              </span>
            </div>
            <p className="mt-4 text-slate-400 text-sm max-w-md leading-relaxed">
              The Global Semiconductor & Component Exchange. Connecting
              manufacturers, distributors and enterprise buyers across 15+
              countries.
            </p>
          </div>
          <FooterCol
            title="Company"
            items={["About", "Careers", "Compliance", "Press"]}
          />
          <FooterCol
            title="Sourcing"
            items={["CPU", "SSD / Storage", "Memory", "GPU", "Networking"]}
          />
          <FooterCol
            title="Desks"
            items={[
              "Singapore",
              "Hong Kong",
            ]}
          />
          <div className="md:col-span-2" data-testid="footer-contact">
            <div className="text-[11px] font-mono tracking-[0.22em] uppercase text-slate-500 mb-4">
              Contact
            </div>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <Mail className="w-4 h-4 text-electric-500 mt-0.5 shrink-0" strokeWidth={1.6} />
                <a
                  href="mailto:sales@omnicoretek.com"
                  data-testid="footer-contact-email"
                  className="text-sm text-slate-300 hover:text-white break-all electric-underline"
                >
                  sales@omnicoretek.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[11px] font-mono tracking-[0.14em] uppercase text-slate-500">
            © {new Date().getFullYear()} OmniCoreTek Exchange. All rights
            reserved.
          </p>
          <div className="flex items-center gap-6 text-[11px] font-mono tracking-[0.14em] uppercase text-slate-500">
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Trade Compliance</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div className="md:col-span-2">
      <div className="text-[11px] font-mono tracking-[0.22em] uppercase text-slate-500 mb-4">
        {title}
      </div>
      <ul className="space-y-2.5">
        {items.map((i) => (
          <li key={i}>
            <a href="#" className="text-sm text-slate-300 hover:text-white electric-underline">
              {i}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
